module.exports = __webpack_public_path__ + "img/longdomap.e4edfe83.jpg";